import {TicketFromApi} from '../../../app/interfaces/ticket';
import {CustomerLight} from '../../Auth/Types/customer';

/**
 * Construit le chemin vers le détail d'un ticket en transmettant le `customerId`
 * attendu par TicketDetailIndex. Le `customerId` provient de la BU du ticket,
 * ou à défaut de l'identifiant du client courant.
 */
export const ticketDetailPath = (
  ticket: TicketFromApi,
  customer: CustomerLight | undefined
): string => {
  const customerId =
    ticket.bu === null ? (customer?.id?.toString() ?? '') : ticket.bu.toString();
  return `/support/${ticket.numDossier.toString()}?customerId=${customerId}`;
};
